import { Button, PopUp, PopUpProps, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const styles = StyleSheet.create({
  container: {
    maxWidth: 600,
  },
  text: {
    marginTop: Spacing.L,
    marginBottom: Spacing.L,
  },
  bottom: {
    marginTop: Spacing.L,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginHorizontal: -Spacing.XS,
  },
  button: {
    marginHorizontal: Spacing.XS,
  },
})

interface Props extends PopUpProps {
  onUninstall?: (email?: string) => void
}
const UninstallConfirm = (props: Props) => {
  const { style, onClose, onUninstall, ...otherProps } = props
  const { t } = useTranslation()

  return (
    <PopUp onClose={onClose} style={[styles.container, style]} {...otherProps}>
      <Text level={2}>
        <Trans>Uninstall device from workspace</Trans>
      </Text>
      <Text style={styles.text}>
        <Trans>
          You are about to remove the device from the workspace. The device will have no location anymore. This action
          can only be reversed by reinstallation with the commissioining app.
        </Trans>
      </Text>
      <View style={styles.bottom}>
        <Button
          left="trash"
          title={t('Uninstall device')}
          size="L"
          danger
          onPress={() => onUninstall?.()}
          testID="UninstallConfirm.Confirm"
          style={styles.button}
        />
        <Button title={t('Cancel')} size="L" onPress={onClose} testID="UninstallConfirm.Cancel" style={styles.button} />
      </View>
    </PopUp>
  )
}

export default UninstallConfirm
